import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./fonts/FKRomanStandard/FKRomanStandard-Regular.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22./fonts/FKRomanStandard/FKRomanStandard-Oblique.woff2%22,%22weight%22:%22400%22,%22style%22:%22italic%22},{%22path%22:%22./fonts/FKRomanStandard/FKRomanStandard-Bold.woff2%22,%22weight%22:%22700%22,%22style%22:%22normal%22},{%22path%22:%22./fonts/FKRomanStandard/FKRomanStandard-BoldOblique.woff2%22,%22weight%22:%22700%22,%22style%22:%22italic%22}],%22preload%22:false,%22variable%22:%22--font-fkroman%22,%22fallback%22:[%22Georgia%22,%22serif%22],%22display%22:%22swap%22,%22adjustFontFallback%22:%22Times%20New%20Roman%22}],%22variableName%22:%22fkRomanStandard%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'fkRomanStandard', 'fkRomanStandard Fallback', Georgia, serif",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
